let routes = [{
		path: '/',
		name: 'layout',
		redirect: {
			name: 'index'
		},
		component: 'layout',
		children: [
			{
				meta:{title:'home'},
				component: 'index/index'
			},
			
			{
				meta:{title:'user'},
				component: 'user/index'
			},			
			{
				meta:{title:'warn'},
				component: 'data/warn'
			},				
			{
				meta:{title:'apply'},
				component: 'account/apply'
			},				
			{
				meta:{title:'total'},
				component: 'data/day'
			},{
				meta:{title:'mon'},
				component: 'data/mon'
			},				
			{
				meta:{title:'apply'},
				component: 'order/apply'
			},		
			{
				meta:{title:'order'},
				component: 'order/index'
			},
			{
				meta:{title:'pay'},
				component: 'order/pay'
			},
			{
				meta:{title:'cert'},
				component: 'cdn/cert'
			},
			{
				meta:{title:'domain'},
				component: 'cdn/detail'
			},
			{
				meta:{title:'product'},
				component: 'cdn/product'
			},
			{
				meta:{title:'domain'},
				component: 'cdn/domain'
			},
			{
				meta:{title:'account'},
				component: 'account/index'
			},
			
			{
				meta:{title:'agent'},
				component: 'agent/index'
			},
			{
				meta:{title:'setBase'},
				component: 'set/base/index'
			},
			{
				meta:{title:'role'},
				component: 'set/manager/index'
			},
			{
				meta:{title:'managerRule'},
				component: 'set/manager/rule'
			},
			{
				meta:{title:'adminList'},
				component: 'set/admin/index'
			},
			{
				meta:{title:'userList'},
				component: 'al/user'
			},
			
			{
				meta:{title:'userList'},
				component: 'aws/user'
			},
			{
				meta:{title:'bill'},
				component: 'al/bill'
			},
	
			{
				meta:{title:'bill'},
				component: 'aws/bill'
			},
			{
				meta:{title:'apply'},
				component: 'al/apply'
			},
			
			{
				meta:{title:'apply'},
				component: 'aws/apply'
			},
			
			{
				meta:{title:'message'},
				component: 'data/message'
			},
			{
				meta:{title:'404'},
				component: 'error/404'
			},
			
			{
				meta:{title:'account'},
				component: 'tx/account'
			},
			{
				meta:{title:'reg'},
				component: 'user/reg'
			},
			{
				meta:{title:'order'},
				component: 'tx/order'
			},
			{
				meta:{title:'apply'},
				component: 'tx/apply'
			},
			{
				meta:{title:'ctotal'},
				component: 'tx/total'
			},
		]
	},
	{
		// path:'/login',
		// name:'login',
		//component:()=>import('../../views/login/index.vue')
		meta:{title:'登錄页'},
		component: 'login/index'
	},
	{
		path: '*',
		redirect: {
			name: 'index'
		}
	}
]
// 获取路由信息方法
let getRoutes = function() {
	// 生成路由详细信息
	createRoute(routes)
	return routes
}
// 自动生成路由
function createRoute(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 去除index
		let val = getValue(arr[i].component)
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成apth
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}
// 去除index
function getValue(str) {
	// str = login/index
	// 获取最後一个/索引
	let index = str.lastIndexOf('/')
	// 获取最後一个/後面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(index, -1)
	}
	return str
}
export default getRoutes()
